import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';

/**
 * This component displays a slider control to set the esri layer opacity.
 *
 * @export
 * @class LayerOpacityComponent
 * @implements {OnInit}
 */
@Component({
    selector: 'app-layer-opacity',
    templateUrl: './layer-opacity.component.html',
    standalone: false
})
export class LayerOpacityComponent implements OnInit {
  @ViewChild('opacitySlider', { static: true }) opacitySlider: ElementRef;
  @Input() featureLayer: any;
  private _opacityVal: number;

  constructor() {}

  ngOnInit() {
    this.createOpacityNode();
  }

  createOpacityNode() {
    this.layerOpacity = this.featureLayer.opacity * 100;
  }

  /**
   * Gets the layer opacity.
   * @type {number}
   * @memberof LayerOpacityComponent
   */
  get layerOpacity(): number {
    return this._opacityVal;
  }

  /**
   * Sets the layer opacity.
   * @memberof LayerOpacityComponent
   */
  set layerOpacity(val: number) {
    if (val > 100) val = 100;
    if (val < 0) val = 0;

    this.featureLayer.opacity = val / 100;
    this.opacitySlider.nativeElement.style.setProperty('--val', val);
    this._opacityVal = val;
  }
}
